<template>
  <div class="ImportLibrariesTableComponent DataTables">

      <div :id="id">aaa</div>
 </div>
</template>

<script>

  var $ = require('jquery');
  var jQuery = $
  window.$ = $
  window.jQuery = $
  var jquery = $;
  import 'bootstrap-vue/dist/bootstrap-vue.css'

  require("datatables.net");
  require("datatables.net-bs4");



  import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'

  import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'


  //import { mapGetters } from 'vuex'
  import LibraryFilesType from '@/constants/LibraryFilesType'

export default {
  name: 'ImportLibrariesTableComponent',
  props:{
    lang: Object,
    data: Array
  },
  components: {

  },
  data () {
      return {
        name: "FormLibraryPropertiesComponent",
        id: "tableplace_"+this._uid,

        mainTable: "",
      }
  },
  computed: {
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }

    }
  },
  created () {


  },
  mounted: function () {
    this.prepareData();
  },
  watch: {
    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.prepareData(this.categoryId, this);

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
    data: {
      handler: function(newVal, oldVal){
        console.log("tu")
        this.prepareData();
      },
      deep: true

    },
  },
  methods: {
    prepareData() {
      this.libraries = [];
      console.log(this.data, this.data.length)

      for (let i = 0, lei = this.data.length; i < lei; i++){

        const obj = {
          libraryId: this.data[i].libraryId,
          name: this.data[i].name,
          type: this.data[i].type,
          category: this.data[i].category,
          status: this.data[i].status,
          files: this.data[i].files.split(";"),
          path: this.data[i].path,
          message: this.data[i].message,
          select: this.data[i].status == "error" ? false : true
        }
        this.libraries.push(obj);


      }

      if (this.data.length > 0) {
        this.buildTable();
      }

    },
    checkCheckboxes() {

      let vue = this;

      const selected = [];

      $('#place' + this._uid + ' tbody input[type="checkbox"]').each(function () {

          const checked = $(this).is(':checked');
          if (vue.mainTable != ""){

            const rowData = vue.mainTable.row($(this).closest('tr')).data();


            if (rowData.select == true){

              selected.push(rowData);
            }

          }

      });
      this.$store.commit("SETCSVIMPORT", selected)
    },
    buildTable(){


      let tableplace = document.getElementById("tableplace_"+this._uid);

      if (tableplace == null) {
        return;
      }
      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }



      let place = document.createElement("table");
      place.setAttribute("id", "place"+this._uid);
      place.setAttribute("class", "table table-striped table-bordered");
      place.setAttribute("style", "width:100%;");
      tableplace.appendChild(place)

      let tr1 = document.createElement("tr");
      tr1.setAttribute("class", "cellHeader");
      let thead = document.createElement("thead");
      thead.appendChild(tr1);
      place.appendChild(thead);

      let tr2 = document.createElement("tr");
      tr2.setAttribute("class", "cellFooter");
      let tfoot = document.createElement("tfoot");
      tfoot.appendChild(tr2);
      place.appendChild(tfoot);

      let cols = [];

      let columnDefs = [];

      let columns = [
        // {
        //   name: "Id",
        //   alignInColumn: "left",

        // },
        {
          name: this.lang.table_header_Name,
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Type,
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Category,
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Files,
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Path,
          alignInColumn: "left",
        },
        {
          name: this.lang.table_header_Status,
          alignInColumn: "center",

        },
        {
          name: this.lang.table_header_Message,
          alignInColumn: "center",

        },
        {
          name: this.lang.table_header_Action,
          alignInColumn: "center",

        },

      ]

      let _vue = this;

      let len = columns.length;
      for (let i = 0; i < len; i++){



        let el = {};

        el = {
          targets: i,
          className: '_dt-body-'+ columns[i].alignInColumn,
          render: function (data, type, row, meta) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            if (data.display != undefined) {
              data.display = $.fn.dataTable.render.text().display(data.display);
            }

            let disabled = "";
            if (row.origins != "own"){
              disabled = "disabled=\"disabled\"";
            }
            if (meta.col == 0){

              return  data
            }else if (meta.col == 1){

              return data

            }else if(meta.col == 2){

              return data;
            } else if (meta.col == 3) {

              let str = "";
              for (let i = 0, lei = data.length; i < lei; i++){
                let exts = null;
                if (row.type == "footprint") {
                  exts = LibraryFilesType.FOOTPRINT

                }
                if (row.type == "padstack") {
                  exts = LibraryFilesType.PADSTACK

                }
                if (row.type == "shape") {
                  exts = LibraryFilesType.SHAPE

                }
                if (row.type == "flash") {
                  exts = LibraryFilesType.FLASH

                }
                if (row.type == "part" || row.type == "symbol") {
                  exts = LibraryFilesType.PART;

                }
                if (row.type == "hdl symbol") {
                  exts = LibraryFilesType.HDLSYMBOL;

                }
                let choosenExt = null;
                if (exts !== null){
                  choosenExt = exts.some(ext =>
                    data[i].toLowerCase().endsWith(ext.toLowerCase())
                  );


                }

                if (choosenExt) {
                  str += "<span class=\"highlighted-files\">" + data[i] + "</span>";
                } else {
                  str += data[i];
                }



                str += "<br>";
              }

              return str;
            } else if (meta.col == 4) {
              return data
            }else if(meta.col == 5){
              let variant = "success";
              if (data == "new revision"){
                return data;
              }
              if (data == "new library"){
                return data;
              }
              if (data == "error") {
                variant = "danger";
              }

              return "<span class='badge badge-"+variant+"'>" + data + "</span>";
            }else if(meta.col == 6){
              return data
            } else {

              let checked, disabled = "disabled";
              if (row.status != "error"){
                disabled = "";
                checked = "checked";
              }

              let str = "<div class=\"custom-control custom-checkbox\"><input "+disabled+" " + checked + "  type=\"checkbox\" class=\"custom-control checkbox_type custom-control-primary custom-control-sm  input-select\" id=\"id_" + row.type + "_" + row.name +"\" value=\""+ checked +"\"></div>";

              return  str + row.select;
            }


          }
        }



        columnDefs.push(el);



        cols =  [
            //{ "data": "libraryId" },
            { "data": "name" },
            { "data": "type" },
            { "data": "category" },
            { "data": "files" },
            { "data": "path" },
            { "data": "status" },
            { "data": "message" },
            { "data": "select" },

        ]



        let th = document.createElement("th");
        //var th2 = document.createElement("th");
        tr1.appendChild(th);
        //tr2.appendChild(th2);
        //var p = document.createElement("p");
        //th.appendChild(p);
        let br = document.createElement("br");
        th.appendChild(br);

        let tx = document.createTextNode(columns[i].name)
        th.appendChild(tx);

      }




      let json = {};


      json.keys = false;
      json.data= this.libraries;
      json.myColumnFormats = columns;
      json.colReorder = false;
      json.paging = false;
      json.select = false;
      json.columns = cols;
      json.columnDefs = columnDefs;
      json.dom = '<f<t>ip>';
      json.order = [1, "asc"];
      json.ordering = true;

      json.initComplete = function () {

      }


      if ($.fn.dataTable.isDataTable('#place'+this._uid)) {
          this.mainTable.destroy();

      }



      this.mainTable = $('#place'+this._uid).DataTable(json);
      this.mainTable.one('draw.dt', function () {


        _vue.checkCheckboxes();

      });

      this.mainTable.columns.adjust().draw();



      //this.$parent.$parent.$parent.$parent.$parent.$parent.propsTable = this.mainTable;


      //hide first column in table
      //this.mainTable.column( 0 ).visible( false );
      //this.mainTable.column( 1 ).visible( false );



      //search input change view
      let searchplace = document.getElementById("place"+this._uid+"_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:"){
            searchplace.removeChild(searchplace.firstChild);
            break;
        }

      }


      searchplace.firstChild.setAttribute("placeholder", "Enter search words")
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm");
      searchplace.firstChild.setAttribute("id", "props_search");
      searchplace.firstChild.addEventListener("input", function(evt){

        _vue.$store.dispatch("setFilteredData", evt.target.value);

      })


      let checkboxes_input_select = document.getElementsByClassName("input-select");


      for (let i = 0; i < checkboxes_input_select.length; i++) {
        checkboxes_input_select[i].addEventListener('click', function (vue){


          let tr = $(this).closest('tr');
          let row = _vue.mainTable.row( tr );

          let data = row.data();



          const rowsArray = _vue.mainTable.rows().data().toArray();



          for (let el in rowsArray) {

            console.log(rowsArray[el].name,rowsArray[el].files)
            if (data.name == rowsArray[el].name && data.type == rowsArray[el].type) {

              rowsArray[el].select = this.checked;
            }
          }

          const selected = rowsArray.filter(obj => obj.select === true);

          _vue.$store.commit("SETCSVIMPORT", selected)



          console.log(this.checked)

          console.log(rowsArray);

        }, false);
      }



    },


  }
}
</script>


<style lang="scss">

  .ImportLibrariesTableComponent{

    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .highlighted-files{
      color:orange;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/shared/ImportLibrariesTableComponent.vue